import { render, staticRenderFns } from "./DeclineCertificateReanalysisRequestButton.vue?vue&type=template&id=5f100f92&scoped=true&"
import script from "./DeclineCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"
export * from "./DeclineCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f100f92",
  null
  
)

export default component.exports